import { useCallback, useState } from "react";
import type { ConfirmOptions } from "../types";
import { Modal } from "./Modal";

interface PendingConfirmation extends ConfirmOptions {
  resolve: (value: boolean) => void;
}

export function useConfirmation() {
  const [pending, setPending] = useState<PendingConfirmation | null>(null);

  const confirm = useCallback((options: ConfirmOptions) => new Promise<boolean>((resolve) => {
    setPending({ ...options, resolve });
  }), []);

  const finish = useCallback((value: boolean) => {
    setPending((current) => {
      current?.resolve(value);
      return null;
    });
  }, []);

  const dialog = (
    <Modal
      open={Boolean(pending)}
      title={pending?.title || "Confirm action"}
      eyebrow="CONFIRM"
      onClose={() => finish(false)}
      footer={
        <>
          <button className="button text" type="button" onClick={() => finish(false)}>Cancel</button>
          <button
            className={`button ${pending?.destructive ? "danger" : "primary"}`}
            type="button"
            onClick={() => finish(true)}
          >
            {pending?.confirmLabel || "Confirm"}
          </button>
        </>
      }
    >
      <p className="muted modal-message">{pending?.message}</p>
    </Modal>
  );

  return { confirm, confirmationDialog: dialog };
}
